import Specialist from '../model/Specialist';
import { capitalizeFirstLetter } from './common';

export const generateSpecialities = (specialities: string[] = []) => {
  if (specialities.length < 2) {
    return specialities[0];
  }

  const headSpecialities = specialities.slice(0, -1);
  return `${headSpecialities.join(',')} and ${specialities.slice(-1)}`;
};

export const getSpecialistDisplayName = ({ title, firstName, lastName }: Specialist) => (
  `${title ? `${capitalizeFirstLetter(title)} ` : ''}${firstName} ${lastName}`
);
